import React from 'react';
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { Client } from './api/Client';
import { ClientContextProvider } from 'react-fetching-library';
import { Buffer } from 'buffer';
import { disableConsoleInProduction } from './utils/disableConsole';

// Disable console logs in production
disableConsoleInProduction();

// @ts-ignore
window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ClientContextProvider client={Client}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </ClientContextProvider>
    </Provider>
  </React.StrictMode>
); 